import { render, staticRenderFns } from "./TranslateLanguagesData.vue?vue&type=template&id=bce3cde8"
import script from "./TranslateLanguagesData.vue?vue&type=script&lang=js"
export * from "./TranslateLanguagesData.vue?vue&type=script&lang=js"
import style0 from "./TranslateLanguagesData.vue?vue&type=style&index=0&id=bce3cde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports